import { createStore, ObservableMap } from "@stencil/store";
import { NOTIFICATION_TYPES, NotificationTypeId } from "../../../api/notificationType";
import { SOFTWARE_TYPES, SoftwareType } from "../../../api/software";
import { APPLICATION_IDS, ApplicationId, TECHNOLOGIES_WITH_APPLICATION } from "../../../api/applications";

export interface FormStoreState {
    selectedNotificationType: NotificationTypeId | null;
    selectedSoftwareType: SoftwareType | null;
    selectedApplication: ApplicationId | null;
    formIsSubmitted: boolean;
    selectedMachineTechnology: string | null;
    showErrorNumbers: boolean;
    showApplications: boolean;
    showSoftwareModules: boolean;
    showMachines: boolean;
    showSoftwareFields: boolean;
    showWeldingApplicationFields: boolean;
}
export type FormStore = ObservableMap<FormStoreState>;
export const createFormStore = () => {
    const store = createStore<FormStoreState>({
        selectedNotificationType: null,
        selectedSoftwareType: null,
        selectedApplication: null,
        formIsSubmitted: false,
        selectedMachineTechnology: null,
        showErrorNumbers: true,
        showApplications: false,
        showSoftwareModules: false,
        showMachines: true,
        showSoftwareFields: false,
        showWeldingApplicationFields: false
    });

    store.onChange("selectedNotificationType", (selectedNotificationType) => {
        switch (selectedNotificationType) {
            case null:
            case NOTIFICATION_TYPES.FAULT_WITHOUT_STOP:
            case NOTIFICATION_TYPES.MACHINE_STOP: // TODO: this should be in relation to the selected machine type
            case NOTIFICATION_TYPES.APPLICATION_ISSUES:
                store.state.showErrorNumbers = true;
                break;
            default:
                store.state.showErrorNumbers = false;
                break;
        }
        store.state.showMachines = selectedNotificationType !== NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE;
        store.state.showSoftwareFields = selectedNotificationType === NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE;
    });

    store.onChange("selectedApplication", (selectedApplication) => {
        store.state.showWeldingApplicationFields = selectedApplication === APPLICATION_IDS.WELDING;
    });

    store.onChange("selectedMachineTechnology", () => determineShowApplications());
    store.onChange("selectedNotificationType", () => determineShowApplications());

    function determineShowApplications() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showApplications =
            selectedNotificationType === NOTIFICATION_TYPES.APPLICATION_ISSUES &&
            TECHNOLOGIES_WITH_APPLICATION.includes(selectedMachineTechnology as string);
    }

    store.onChange("selectedSoftwareType", (selectedSoftwareType) => {
        switch (selectedSoftwareType) {
            case SOFTWARE_TYPES.TRUTOPS:
            case SOFTWARE_TYPES.TRUTOPS_FAB:
            case SOFTWARE_TYPES.TRUTOPS_BOOST:
                store.state.showSoftwareModules = true;
                break;
            case null:
            default:
                store.state.showSoftwareModules = false;
                break;
        }
    });

    return store;
};
